import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D3299EA1-1120-4457-86B0-7162B329B826
 * name monitor-arrow-down-variant
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-arrow-down-variant.svg
 * tags
 * - Device / Tech 
 */
export const MonitorArrowDownVariantIcon = createSvgIcon(<><path d="M17 14L22 9L20.6 7.6L18 10.2V3H16V10.2L13.4 7.6L12 9L17 14M23 14V16C23 17.1 22.1 18 21 18H14V20H16V22H8V20H10V18H3C1.9 18 1 17.1 1 16V4C1 2.9 1.9 2 3 2H12V4H3V16H21V14H23Z" /></>, 'MonitorArrowDownVariantIcon');
export default MonitorArrowDownVariantIcon